import * as React from "react";

import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border_km bg-background_km border-input px-3 py-2 text-base ring-offset-background_km file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground_km placeholder:text-muted_km-foreground focus-visible:outline-none focus-visible:ring_km-2 focus-visible:ring-ring_km focus-visible:ring_km-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };